export default "__VITE_ASSET__BxtjfxIU__"